import React, { useState, useCallback } from "react";
import { SettingToggle, Banner, Card } from "@shopify/polaris";
import { useSelector, useDispatch } from "react-redux";
const Mollie = () => {
  const dispatch = useDispatch();
  const dataSettings = useSelector((state) => state.dataSettings);

  return (
    <div style={{ marginTop: "20px" }}>
      <Card
        sectioned
        title="Mollie Payment Setup (Just install when you are using Mollie Payment Gateway)"
      >
        <Banner
          title="How to sync tracking when you use Mollie payment gateway?"
          action={{
            content: "View docs",
            url: "https://help.omegatheme.com/en/article/how-to-sync-tracking-when-you-use-mollie-payment-gateway-yshkzo/?bust=1628483364925",
          }}
          status="info"
        >
          <p>
            Because of security and safety issues for customers, please create
            an access token according to the instructions below, then send it to
            us through support channels.
            <br />
            Note: We only require minimal permission to sync tracking numbers to
            PayPal.
          </p>
        </Banner>
      </Card>
      <Card sectioned title="ClichFunnels & Checkify Setup">
        When you use Clickfunnels, we need your client ID and secret to connect
        with Clickfunnels and sync the tracking information.
        <br /> Please follow these steps below and update me required info:
        <br />
        <div className="ml-3 mt-2" style={{ lineHeight: "24px" }}>
          1. Login to{" "}
          <a
            href="https://developer.paypal.com/developer/applications/"
            target="_blank"
          >
            Paypal Developer Dashboard.
          </a>{" "}
          <br />
          2. On <b>My Apps & Credentials</b> menu, Click <b>Live</b> box. <br />
          3. Click <b>Create App</b>. <br />
          4. Type <b>App Name</b> and click <b>Create App</b>. <br />
          5. In the <b>APP SETTINGS</b> box, in the App feature options section.
          You have selected <b>Disputes and Transaction Search</b> to authorize
          us to send Tracking code
          <br />
          6. Copy Client ID & Secret and send me via Chat
        </div>
      </Card>
    </div>
  );
};

export default Mollie;
